import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgToast',
})
export default class CmgToast extends Vue {
  @Prop({ required: true, default: true, type: Boolean })
  visible!: boolean;

  @Prop({ required: false, default: 'white', type: String })
  background!: string;

  @Prop({ required: false, type: String })
  manualWidth?: string;
  
  @Prop({ required: false, default: '', type: String })
  backgroundImage!: string;

  @Prop({ required: false, default: '', type: String })
  ariaLabel!: string;

  @Prop({ required: false, default: '', type: String })
  ariaRole!: string;

  @Prop({ required: false, default: '', type: String })
  id!: string;

  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  close() {
    this.$services.ui.setToastVisibility(false);
  }
}